import { IAction } from '../../interface/action/action.interface';
import { ActionEnum } from '../../enum/action.enum';

export function isValidAction(action: any): action is IAction {
  return Boolean(action && action.type !== undefined && action.type !== null && ActionEnum[ action.type ] !== undefined);
}
